import React, { Fragment } from 'react';
import { Container, Row, Col } from 'reactstrap';
import BlogBox from './BlogDetail/BlogBox';
import Perspiciatis from './BlogDetail/Perspiciatis';
import Gallery from './BlogDetail/Gallery';
import { useNavigate } from 'react-router';
import { Btn, Breadcrumbs, H4 } from '../../AbstractElements';
import Button from 'react-bootstrap/Button';

const BlogDetailContain = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`${process.env.PUBLIC_URL}/blog/blogPost`);
  };

  return (
    <Fragment>
      <div className='row'>
        <div className='col-12 col-md-6 col-lg-6'>
          <Breadcrumbs mainTitle="Blogs" parent="Tables" title="Blogs" />
        </div>
        <div className='col-12 col-md-6 col-lg-6'>
          <Button onClick={handleClick} className='btn btn-primary float-end'>Create Blog</Button>
        </div>
      </div>
      <Container fluid={true} className="blog-page mb-4">
        <Gallery />
      </Container>
    </Fragment>
  );
};

export default BlogDetailContain;
